// @TODO: combine this with ClassroomGoal/EditGoalDialog
/*
 * Ryan O'Dowd
 * 2024-05-17
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import {
  apiAdminCreateClassroomGoal,
  apiCreateClassroomGoal,
} from '@utils/store/actions';
import Button from '@components/common/Button';
import DateRange from '../../ClassroomGoal/DateRange'; // @TODO: should be moved outside of ClassroomGoal
import Dialog from '@components/common/Dialog';
import FormControl from '@components/common/FormControl';
import Icon from '@react-native-vector-icons/material-design-icons';
import TextInput from '@components/common/TextInput';
import Tooltip from '@components/common/Tooltip';
import {
  View,
} from 'react-native';
import {
  format as dateFnsFormat,
} from 'date-fns';
import getStyles from './styles';
import hooks from '@hooks';

const NewGoalDialog = (props: NewGoalDialogProps) => { // @TODO: abstract this with MyCampaigns/CampaignPreview
  const styles = hooks.useStyles(getStyles);
  const i18n = hooks.useI18n();
  const navigation = hooks.useNavigation();
  const dispatch = hooks.useTypedDispatch();

  const [_newGoalTitle, setNewGoalTitle] = useState('');
  const [_pipeDelimitedText, setPipeDelimitedText] = useState('');
  const [_validationError, setValidationError] = useState('');
  const [_dateAvailable, setDateAvailable] = useState(null);
  const [_dateDeadline, setDateDeadline] = useState(null);

  const isAdmin = hooks.useIsAdmin();

  if (!props.isOpen) {
    return null;
  }

  return (
    <Dialog
      visible={props.isOpen}
      onDismiss={props.onClose}
    >
      <Dialog.Title>Create new goal</Dialog.Title>{/* @TODO: i18n */}
      <Dialog.Content>
        <TextInput
          value={_newGoalTitle}
          mode='outlined'
          onChangeText={(text) => setNewGoalTitle(text)}
          label='Goal name'
          placeholder={`e.g. "5th Grade Verses, Fall ${dateFnsFormat(new Date(), 'yyyy', {locale: i18n.dateFnsLocale})}"`}// @TODO: better placeholder
        />

        <DateRange
          dateAvailable={_dateAvailable}
          dateDeadline={_dateDeadline}
          setDateAvailable={(newValue) => setDateAvailable(newValue)}
          setDateDeadline={(newValue) => setDateDeadline(newValue)}
          // @TODO: shouldn't be able to pick end date that's before start date
          hideClear={true}
          headerRight={
            <Tooltip title='Goal availability and due dates can be changed at any time'>
              <Icon name='information' style={styles.infoButton} />
            </Tooltip>
          }
        />

        {isAdmin &&
          <FormControl
            addPadding={true}
            label='Admin options'
            style={styles.adminSettingsWrapper}
          >
            <View style={styles.adminOptionsInner}>
              <TextInput
                value={_pipeDelimitedText}
                mode='outlined'
                onChangeText={(text) => setPipeDelimitedText(text)}
                label='Pipe-delimited goal data'
                placeholder={`e.g. "name|description|tag1,tag2|passage1,passage2"`}
              />

              <Button
                onPress={() => {
                  dispatch(apiAdminCreateClassroomGoal(props.classroomId, _pipeDelimitedText));
                  // @TODO: show success/failure (and clear text input on success)
                }}
              >
                Save
              </Button>
            </View>
          </FormControl>
        }
        <p style={styles.errorText}>{_validationError}</p>{/* @TODO: used to be in actions (mui), now in paper needs to be here... */}
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          mode='text'
          onPress={props.onClose}
        >
          {i18n('cancel')}
        </Button>
        <Button
          onPress={() => {
            if (!_newGoalTitle) {
              setValidationError('Goal name is required');
            } else if (!isAdmin && (!_dateAvailable || !_dateDeadline)) {
              setValidationError('Availability and due dates are required');
            } else {
              setValidationError('');
              // @TODO: show loading indicator
              dispatch(apiCreateClassroomGoal(props.classroomId, _newGoalTitle, _dateAvailable, _dateDeadline, (newGoalId) => navigation.navigate(`/schools/${props.schoolId}/classrooms/${props.classroomId}/goals/${newGoalId}`)));
            }
          }}
        >
          {i18n('save')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

class NewGoalDialogProps {
  classroomId: number;
  schoolId: number;
  isOpen: boolean;
  onClose: () => void;
};

export default NewGoalDialog;
